import React from "react";
import Loadable from "../../react-loadable";

const WeaYear = Loadable({
  loader: () => import("./Year"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaYear;



// WEBPACK FOOTER //
// ./ecology9/wea-year/index.js